import { ContactTarget } from '@/customer/models/Customer';
import BaseModel from '@/shared/models/BaseModel';
import { Url } from '@/shared/models/common';
import { present } from '@/shared/utils/typescript';
import PaymentStatus from '../constants/PaymentStatus';
import { ReadyForPickupServiceData } from './ReadyForPickupData';

export interface PaymentRequestId {__paymentRequestId: number}

export default class PaymentRequest extends BaseModel<PaymentRequestId> {
  amount = 0;
  reference = '';
  attachment: Url | null = null;
  status = PaymentStatus.OPEN;
  targets: Array<ContactTarget> = [];

  static withData(data: Partial<PaymentRequest>): PaymentRequest {
    return Object.assign(new PaymentRequest(), data);
  }

  static fromReadyForPickup(data: ReadyForPickupServiceData): PaymentRequest {
    return PaymentRequest.withData({
      amount: present(data.payment.amount),
      reference: data.payment.reference,
      targets: data.targets.map(t => t.target),
      attachment: data.payment.attachment?.content,
    });
  }
}
